import { render, staticRenderFns } from "./SPReport.vue?vue&type=template&id=8ec97cb4&"
import script from "./SPReport.vue?vue&type=script&lang=js&"
export * from "./SPReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports